"use strict";Object.defineProperty(exports,"__esModule",{value:!0});const x={ghost:{large:{x:"1px",y:"1px"},small:{x:"1px",y:"0px"}},lowContrast:{large:{x:"6px",y:"6px"},small:{x:"4px",y:"4px"}},highContrast:{large:{x:"6px",y:"6px"},small:{x:"4px",y:"4px"}},getOffset:function(e,t,l){let p={x:"0px",y:"0px"};return"small"!==t&&"large"!==t||(p=x[e][t]),{x:l&&l.x?l.x:p.x,y:l&&l.y?l.y:p.y}}};exports.default=x;



//////////////////
// WEBPACK FOOTER
// ./~/@vds-core/button-icons/cjs/util/badgeIndictorOffSetConfig.js
// module id = 846
// module chunks = 0